import { connect } from 'react-redux';
import React from 'react';
import { bindActionCreators } from 'redux';
import { apiCallFailure } from 'app/actions';
import { DAY_TIME_HM } from 'app/constants';
import { renderKBDateInput, renderKBSelect, withReduxFormFieldProps } from 'components/formAdapters/reduxFormAdapters';
import { Field, reduxForm } from 'redux-form';
import { api,
apiUtils } from 'app/services';
import { getServiceErrorMessage } from 'utils/kbUtil';
import {
KBPopover,
KBUserInput,
KBFormError,
KBButton,
KBPopoverTop,
KBToReportCenter } from
'components';
import dayjs from 'utils/dayjs';
import { EXPORT_HINT } from 'app/constants/hint';


var ExportLockEventsForm = class extends React.Component {constructor(props) {super(props);this.exportLockEvents = this.exportLockEvents.bind(this);this.changeStartYMDCallback = this.changeStartYMDCallback.bind(this);this.changeStartHMCallback = this.changeStartHMCallback.bind(this);this.changeEndYMDCallback = this.changeEndYMDCallback.bind(this);this.changeEndHMCallback = this.changeEndHMCallback.bind(this);this.setYMD = this.setYMD.bind(this);this.setHM = this.setHM.bind(this);this.getDisabledDays = this.getDisabledDays.bind(this);}exportLockEvents(
  model) {
    delete model.startHM;
    delete model.endHM;
    delete model.startYMD;
    delete model.endYMD;

    model.location_id = this.props.location_id;
    model.start_at = dayjs(model.start_at).format('YYYY-MM-DD HH:mm');
    model.end_at = dayjs(model.end_at).format('YYYY-MM-DD HH:mm');

    return api.lockEventsReport(model).then(
    () => {
      KBPopover.close();
      KBPopoverTop.show(
      <KBToReportCenter
      title="门禁权限导出"
      message="门禁权限列表已成功导出，可以前往报表中心下载" />);


    },
    error => {
      this.props.apiCallFailureActions({
        status: 'error',
        message: getServiceErrorMessage(error) });

    });

  }changeStartYMDCallback(

  data) {
    const {
      fields: { start_at } } =
    this.props;
    this.setYMD(start_at, data);
  }changeStartHMCallback(

  data) {
    const {
      fields: { start_at } } =
    this.props;
    this.setHM(start_at, data);
  }changeEndYMDCallback(

  data) {
    const {
      fields: { end_at } } =
    this.props;
    this.setYMD(end_at, data);
  }changeEndHMCallback(

  data) {
    const {
      fields: { end_at } } =
    this.props;
    this.setHM(end_at, data);
  }setYMD(

  field, value) {
    let date = dayjs(value);
    let year = date.get('year');
    let month = date.get('month');
    let day = date.get('date');
    field.onChange(
    dayjs(field.value).
    clone().
    set({ year, month, date: day }).
    toDate());

  }setHM(

  field, value) {
    let t = value.split(',');
    field.onChange(
    dayjs(field.value).
    clone().
    set({ hour: t[0], minute: t[1] == '1' ? 0 : 30, second: 0 }).
    toDate());

  }getDisabledDays(

  date) {
    // 最近一个月
    const earliest = dayjs().subtract(1, 'month');
    const day = dayjs(date);
    const today = dayjs();
    return !day.isBetween(earliest, today);
  }render()

  {
    const {
      fields: { startHM, endHM, startYMD, endYMD },
      submitting,
      handleSubmit,
      DEAL_DAY_TIME_HM } =
    this.props;
    const halfClass = {
      className: 'kb-form-group kb-div-c48' };

    return (
      <form onSubmit={handleSubmit(this.exportLockEvents)}>
        <KBFormError error={this.props.error} />
        <header className="kb-form-header">
          <h2 className="header-title">导出门禁记录</h2>
          <i
          className="iconfont header-close icon-cancel"
          onClick={KBPopover.close} />

        </header>
        <div className="kb-form-container-m">
          <div className="kb-row kb-form-66">
            <Field name="startYMD" component={renderKBDateInput}
            type="date"
            title="开始日期"
            isRequired={true}
            className="kb-form-group kb-div-48"

            disabledDays={this.getDisabledDays}
            onChange={this.changeStartYMDCallback} />

            <Field name="startHM" component={renderKBSelect}
            title="开始时间"
            onChange={this.changeStartHMCallback}
            titleClass="label-rt"
            arrayData={DEAL_DAY_TIME_HM}

            {...halfClass} />

          </div>
          <div className="kb-row kb-form-66">
            <Field name="endYMD" component={renderKBDateInput}
            type="date"
            title="结束日期"
            isRequired={true}
            className="kb-form-group kb-div-48"

            disabledDays={this.getDisabledDays}
            onChange={this.changeEndYMDCallback} />

            <Field name="endHM" component={renderKBSelect}
            title="结束时间"
            onChange={this.changeEndHMCallback}
            titleClass="label-rt"
            arrayData={DEAL_DAY_TIME_HM}

            {...halfClass} />

          </div>
          <p style={{ fontSize: '12px', color: '#7F8FA4' }}>{EXPORT_HINT.concat_admin}</p>
          <div className="kb-row fixed-form-btn">
            <span className="cancel-btn" onClick={KBPopover.close}>
              取消
            </span>
            <KBButton
            className="certain-btn"
            type="submit"
            submitting={submitting}>

              确定
            </KBButton>
          </div>
        </div>
      </form>);

  }};


function mapStateToProps(state, props) {
  let DEAL_DAY_TIME_HM = DAY_TIME_HM(0, 24);
  return {
    DEAL_DAY_TIME_HM };

}

function mapDispatchToProps(dispatch) {
  return {
    apiCallFailureActions: bindActionCreators(apiCallFailure, dispatch) };

}

const validate = values => {
  const errors = {};

  if (
  values.start_at &&
  values.end_at &&
  dayjs(values.end_at).diff(dayjs(values.start_at)) <= 0)
  {
    errors.endHM = '结束日期必须大于开始日期';
  }

  return errors;
};

const LEGACY_FORM_FIELDS = [
  "start_at",
  "end_at",
  "startHM",
  "endHM",
  "startYMD",
  "endYMD"
];

const formConfig = {
  form: 'ExportLockEventsForm',
  validate: validate,
  touchOnBlur: false };


ExportLockEventsForm = connect(mapStateToProps, mapDispatchToProps)(reduxForm(formConfig)(withReduxFormFieldProps('ExportLockEventsForm', LEGACY_FORM_FIELDS)(ExportLockEventsForm)));

export default ExportLockEventsForm;
